/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:54:46
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import {
  FILL_PAYMENTS_DATA, FILL_INVOICES_DATA, FILL_CORRECTION_INVOICES_DATA,
} from './mutation-types';

export default {
  [FILL_PAYMENTS_DATA](state, payload) {
    const _state = state;
    _state.payments.list = payload.payments.list;
    _state.payments.count = payload.payments.count;
  },

  [FILL_CORRECTION_INVOICES_DATA](state, payload) {
    const _state = state;
    _state.correctionInvoices.list = payload.correction_invoices.list;
    _state.correctionInvoices.count = payload.correction_invoices.count;
  },

  [FILL_INVOICES_DATA](state, payload) {
    const _state = state;
    _state.invoices.list = payload.list;
    _state.invoices.count = payload.count;
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/PaymentsAndInvoices/mutations.js